// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Json_encode from "../../../../../../node_modules/@glennsl/bs-json/src/Json_encode.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var msisdn = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "msisdn"), null));
  if (msisdn.TAG === /* Ok */0) {
    var crn = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "crn"), null));
    if (crn.TAG === /* Ok */0) {
      var $$location = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "location"), null));
      if ($$location.TAG === /* Ok */0) {
        var caller_number = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "caller_number"), null));
        if (caller_number.TAG === /* Ok */0) {
          var order_stage = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_stage"), null));
          if (order_stage.TAG === /* Ok */0) {
            var raised_by = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "raised_by"), null));
            if (raised_by.TAG === /* Ok */0) {
              var issues = Decco.listFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "issues"), null));
              if (issues.TAG === /* Ok */0) {
                var issue_comment = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "issue_comment"), null));
                if (issue_comment.TAG === /* Ok */0) {
                  var actions = Decco.listFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actions"), null));
                  if (actions.TAG === /* Ok */0) {
                    var action_comment = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "action_comment"), null));
                    if (action_comment.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: {
                                msisdn: msisdn._0,
                                crn: crn._0,
                                location: $$location._0,
                                caller_number: caller_number._0,
                                order_stage: order_stage._0,
                                raised_by: raised_by._0,
                                issues: issues._0,
                                issue_comment: issue_comment._0,
                                actions: actions._0,
                                action_comment: action_comment._0
                              }
                            };
                    }
                    var e = action_comment._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".action_comment" + e.path,
                              message: e.message,
                              value: e.value
                            }
                          };
                  }
                  var e$1 = actions._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".actions" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                          }
                        };
                }
                var e$2 = issue_comment._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".issue_comment" + e$2.path,
                          message: e$2.message,
                          value: e$2.value
                        }
                      };
              }
              var e$3 = issues._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".issues" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                      }
                    };
            }
            var e$4 = raised_by._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".raised_by" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = order_stage._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".order_stage" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
        }
        var e$6 = caller_number._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".caller_number" + e$6.path,
                  message: e$6.message,
                  value: e$6.value
                }
              };
      }
      var e$7 = $$location._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".location" + e$7.path,
                message: e$7.message,
                value: e$7.value
              }
            };
    }
    var e$8 = crn._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".crn" + e$8.path,
              message: e$8.message,
              value: e$8.value
            }
          };
  }
  var e$9 = msisdn._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".msisdn" + e$9.path,
            message: e$9.message,
            value: e$9.value
          }
        };
}

function getFromDictString(dict, key) {
  return Belt_Option.flatMap(Js_dict.get(dict, key), (function (str) {
                return str;
              }));
}

function getListFromParam(data) {
  return $$Array.to_list(data.split("|"));
}

function getOptionValue(value) {
  if (value !== undefined) {
    return Caml_option.valFromOption(value);
  } else {
    return ErrorUtils$Catalyst.raiseError("RaiseTicketZingtreeRequestMapper.res", "URL paramter missing", "");
  }
}

function fromDict(map) {
  var msisdn = getFromDictString(map, "msisdn");
  var crn = getFromDictString(map, "crn");
  var $$location = getFromDictString(map, "location");
  var caller_number = getFromDictString(map, "caller_number");
  var order_stage = getFromDictString(map, "order_stage");
  var raised_by = getFromDictString(map, "raised_by");
  var issuesString = getFromDictString(map, "issues");
  var issues = issuesString !== undefined ? $$Array.to_list(issuesString.split("|")) : undefined;
  var actionsString = getFromDictString(map, "actions");
  var actions = actionsString !== undefined ? $$Array.to_list(actionsString.split("|")) : undefined;
  var issue_comment = getFromDictString(map, "issue_comment");
  var action_comment = getFromDictString(map, "action_comment");
  return {
          msisdn: getOptionValue(msisdn),
          crn: getOptionValue(crn),
          location: getOptionValue($$location),
          caller_number: getOptionValue(caller_number),
          order_stage: getOptionValue(order_stage),
          raised_by: getOptionValue(raised_by),
          issues: getOptionValue(issues),
          issue_comment: issue_comment,
          actions: getOptionValue(actions),
          action_comment: action_comment
        };
}

function toDict(param) {
  var action_comment = param.action_comment;
  var issue_comment = param.issue_comment;
  var params = {};
  var setVal = function (value, key) {
    params[key] = value;
    
  };
  setVal(param.msisdn, "msisdn");
  setVal(param.crn, "crn");
  setVal(param.location, "location");
  setVal(param.caller_number, "caller_number");
  setVal(param.order_stage, "order_stage");
  setVal(param.raised_by, "raised_by");
  setVal(Belt_List.toArray(param.issues).join("|"), "issues");
  if (issue_comment !== undefined) {
    setVal(issue_comment, "issue_comment");
  }
  setVal(Belt_List.toArray(param.actions).join("|"), "actions");
  if (action_comment !== undefined) {
    setVal(action_comment, "action_comment");
  }
  return params;
}

function encodeToJson(request) {
  var param = Belt_List.toArray(request.issues).join("|");
  var param$1 = Belt_List.toArray(request.actions).join("|");
  return Json_encode.object_({
              hd: [
                "msisdn",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), request.msisdn)
              ],
              tl: {
                hd: [
                  "crn",
                  Json_encode.nullable((function (prim) {
                          return prim;
                        }), request.crn)
                ],
                tl: {
                  hd: [
                    "location",
                    Json_encode.nullable((function (prim) {
                            return prim;
                          }), request.location)
                  ],
                  tl: {
                    hd: [
                      "caller_number",
                      Json_encode.nullable((function (prim) {
                              return prim;
                            }), request.caller_number)
                    ],
                    tl: {
                      hd: [
                        "order_stage",
                        Json_encode.nullable((function (prim) {
                                return prim;
                              }), request.order_stage)
                      ],
                      tl: {
                        hd: [
                          "raised_by",
                          Json_encode.nullable((function (prim) {
                                  return prim;
                                }), request.raised_by)
                        ],
                        tl: {
                          hd: [
                            "issues",
                            Json_encode.nullable((function (prim) {
                                    return prim;
                                  }), param)
                          ],
                          tl: {
                            hd: [
                              "issue_comment",
                              Json_encode.nullable((function (prim) {
                                      return prim;
                                    }), request.issue_comment)
                            ],
                            tl: {
                              hd: [
                                "actions",
                                Json_encode.nullable((function (prim) {
                                        return prim;
                                      }), param$1)
                              ],
                              tl: {
                                hd: [
                                  "action_comment",
                                  Json_encode.nullable((function (prim) {
                                          return prim;
                                        }), request.action_comment)
                                ],
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

export {
  t_decode ,
  getFromDictString ,
  getListFromParam ,
  getOptionValue ,
  fromDict ,
  toDict ,
  encodeToJson ,
  
}
/* No side effect */
